//========== Error Page Section Component ==========

import { useNavigate } from 'react-router-dom';
import './error.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ErrorArea = () => {
  let navigate = useNavigate();
  const goHome = () => {
    navigate('/');
  };
  return /*#__PURE__*/_jsx("div", {
    className: "error-area",
    children: /*#__PURE__*/_jsxs("div", {
      className: "error-content text-center",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "error-num",
        children: ["404", /*#__PURE__*/_jsx("div", {
          className: "error-num__clip",
          children: "404"
        })]
      }), /*#__PURE__*/_jsx("h2", {
        className: "mb- mt-4",
        children: "Page Not Found"
      }), /*#__PURE__*/_jsx("button", {
        className: "cmn-btn mt-4",
        onClick: goHome,
        children: "Go back to Home"
      })]
    })
  });
};
export default ErrorArea;